/* eslint-disable indent */
import { useEffect, useState, useRef } from "react";
import {
  Alert,
  AlertColor,
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  ClickAwayListener,
  Snackbar,
} from "@mui/material";
import LinearProgress from "@mui/material/LinearProgress";
import { useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useVForm } from "shared/forms";
import {
  FerramentasDeDetalhe,
  InputError,
  ConfirmacaoModal,
} from "shared/components";
import { LayoutBaseDePagina } from "shared/layouts";
import { OrganizationsService } from "shared/services/organizations/organizationsService";
import { CribService } from "shared/services/crib/cribService";
import {
  listKeyValueGrupoControle,
  listKeyValueCalculoGC,
  IUpdateCrib,
  ICampanhas,
  IListagemCribLog,
  IDetalheCampanha,
  IComunicacao,
} from "shared/types";

import { t } from "i18next";
import { useHasPermissionAcao } from "shared/hooks";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import { UsuariosService } from "shared/services/usuarios/usuariosService";
import { useSelectedOrganization } from "shared/store/organization";
import { AMBIENTE_NOT_RELEASE as AMB } from "../../config/env";
import { stringToDateTime } from "shared/utils";

import * as uuid from "uuid";
import * as crypto from "crypto";
import axios from "axios";
import { ApiCrib } from "shared/services/api";
import React from "react";

interface InserirCampanhaError {
  mensagem: string;
  codigo: number;
}

interface CribLogItem {
  TABLE_NAME: string;
}

interface ColumnLogItem {
  COLUMN_NAME: string;
  DATA_TYPE: string;
}

export interface CribBody {
  gc_type: string;
  gc_helper: number;
  query_business: string;
  cmp_id: number;
}

interface IRespListagemCrib {
  cribLogList: IListagemCribLog[];
}

export const ConfiguracaoCrib: React.FC = () => {
  // region Select Tabela
  const [selectedColumn, setSelectedColumn] = useState<ColumnLogItem | null>(
    null
  );
  const [dataType, setDataType] = useState<string | null>(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [open, setOpen] = useState(false);
  const [severity, setSeverity] = useState<"success" | "error">("error");
  const [lastIdExec, setLastIdExec] = useState<number>(0);
  const [isVisibleSms, setIsVisibleSms] = useState<boolean>(false);
  const [isVisibleEmail, setIsVisibleEmail] = useState<boolean>(false);
  const [isVisiblePush, setIsVisiblePush] = useState<boolean>(false);
  const [isVisibleWpp, setIsVisibleWpp] = useState<boolean>(false);

  // region Incluir
  const [focarTitle, setFocarTitle] = useState<boolean>(false);
  const [focarTitlePerc, setFocarTitlePerc] = useState<boolean>(false);
  const [focarTitleInt, setFocarTitleInt] = useState<boolean>(false);
  const [focarTitleIR, setFocarTitleIR] = useState<boolean>(false);
  const [focarTitleFR, setFocarTitleFR] = useState<boolean>(false);
  const [focarTitleCampanha, setFocarTitleCampanha] = useState<boolean>(false);

  function urlBase() {
    if (window.__RUNTIME_CONFIG__.REACT_APP_DEPLOY === "HML") {
      return "https://eva-hom.pefisa.com.br/api/Crib";
    } else if (window.__RUNTIME_CONFIG__.REACT_APP_DEPLOY === "local") {
      return "https://localhost:5002/api/Crib";
    } else if (window.__RUNTIME_CONFIG__.REACT_APP_DEPLOY === "PRD") {
      return "https://eva.pefisa.com.br/api/Crib";
    } else {
      return "";
    }
  }
  function gcTypeCalculator() {
    if (selectTipoGC === 2) {
      return selectGC;
    } else {
      return selectTipoGC + selectGC;
    }
  }

  function gcHelperCalculator() {
    if (selectGC === 1) {
      return selectPercent;
    } else if (selectGC === 2) {
      return selectInteiro;
    } else if (selectGC === 3) {
      return -1;
    } else if (selectGC === 4) {
      return selectInicioRange + selectFimRange;
    }
  }



  const handleSubmitCrib = async () => {
    console.log("tipo gc do form: " + selectTipoGC);
    console.log("gc do form: " + selectGC);

    let gcType;
    let gcHelper;

    if (selectTipoGC == '' || selectGC == null || selectTipoGC == null) {
      if (gcTypeComunicacao === "" || gcTypeComunicacao === null || gcHelperComunicacao === 0 || gcHelperComunicacao === undefined || gcTypeComunicacao === undefined) {
        setAlert({      
          text: "Grupo Controle não pode ser vazio",
          type: "error",
        });
        return;
      }
      gcType = gcTypeComunicacao;
      gcHelper = gcHelperComunicacao;
    } else {
      gcType = String(gcTypeCalculator());
      gcHelper = +gcHelperCalculator();
    }

      // gc_type: gcTypeComunicacao === "" || gcTypeComunicacao === null ? String (gcTypeCalculator()) : gcTypeComunicacao,

      // gc_helper: gcHelperComunicacao === 0 ? + gcHelperCalculator(): gcHelperComunicacao,
    
    const body: CribBody = {
      gc_type: gcType, // Provide a default value if gcType is undefined
      gc_helper: gcHelper,
      query_business: watch("queryBusiness"),
      cmp_id: +selectedItem,
    };
    
    const postToEndpoint = async (
      body: CribBody
    ): Promise<void> => {
      try {
        const sessionData = localStorage.getItem("recoil-persist");
        if (!sessionData) {
          throw new Error("Dados de sessão não encontrados.");
        }
        const codigoOrg = localStorage.getItem("org");
        const parsedData = JSON.parse(sessionData);
        const token = parsedData.sessionUser?.token;
        // Pega a query da comunicação da campanha inserida caso o usuário não tenha digitado a própria query
        body.query_business===""?body.query_business=queryCampanha:console.log("query inserida pelo usuário: "+body.query_business);
        
        const response = await axios.post(
          `https://eva.pefisa.com.br/api/Crib/${codigoOrg}`,
          body,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setLastIdExec(response.data.idExec);
        

        setAlert({
          text: `Campanha enviada para fila de execução - ID: ${response.data.idExec}`,
          type: "info",
        });
      } catch (error: any) {
        console.log(error.response);
        setAlert({
          text:
            typeof error.response.data !== "object"
              ? error.response.status + " - " + error.response.data
              : error.response.status +
                " - " +
                error.response.data.query_validation_error,
          type: "error",
        });
      }
    };
    await postToEndpoint(body);
  };

  const handleClickLog = async () => {
    if (showTest === true) {
      setShowTest(false);
    } else {
      // #region teste log
      const getLog = async (
        idOrg: number,
        idCampanha: number
      ): Promise<IRespListagemCrib | Error> => {
        try {
          const sessionData = localStorage.getItem("recoil-persist");
          if (!sessionData) {
            throw new Error("Dados de sessão não encontrados.");
          }
          const parsedData = JSON.parse(sessionData);
          const token = parsedData.sessionUser?.token;
          const { data } = await ApiCrib.get(
            `https://eva.pefisa.com.br/api/Crib/${idOrg}/${idCampanha}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );

          if (data) {
            return data;
          }
          return new Error("Erro ao listar os registros.");
        } catch (error) {
          return new Error(
            (error as { message: string }).message ||
              "Erro ao listar os registros."
          );
        }
      };

      const Log = async (): Promise<void> => {
        try {
          await getLog(
            Number(org?.CodigoOrganizacao),
            Number(selectedItem)
          ).then((result) => {
            setIsLoading(false);
            if (result instanceof Error) {
              console.log();
              setAlert({
                text: result.message,
                type: "error",
              });
            } else if (typeof result === "string") {
              setAlert({
                text: result,
                type: "error",
              });
            } else {
              setShowTest(true);
              setRows(result.cribLogList);
              setProgressBar(true);
              setLastIdExec(+result.cribLogList[0].IdExec);
            }
          });
        } catch (error: any) {
          console.log(error.response);
        }
      };
      // #endregion
      await Log();
    }
  };

  // endregion

  const [tipoCampanha, setTipoCampanha] = useState("");
  const [queryCampanha, setQueryCampanha] = useState("");
  const [gcTypeComunicacao, setGcTypeComunicacao] = useState("");
  const [gcHelperComunicacao, setGcHelperComunicacao] = useState(0);
  const [Canal, setCanal] = useState<IComunicacao[]>();

  const { id = "novo" } = useParams<"id">();

  const navigate = useNavigate();

  const hasPermitionCreate = useHasPermissionAcao("crib", "CRE");
  const hasPermitionDelete = useHasPermissionAcao("crib", "DEL");
  const hasPermitionUpdate = useHasPermissionAcao("crib", "UPD");

  const [alert, setAlert] = useState<null | { text: string; type: AlertColor }>(
    null
  );
  const { formRef, save, saveAndClose, isSaveAndClose } = useVForm();

  const {
    register,
    handleSubmit,
    reset,
    trigger,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
  });

  const selectGC = watch("calcGrupo");
  const selectFlag = watch("flag");
  const selectPercent = watch("porcentagem");
  const selectTipoGC = watch("grupoControle");
  const selectInteiro = watch("valorInteiro");
  const selectInicioRange = watch("inicioRange");
  const selectFimRange = watch("fimRange");
  const selectCampanha = watch("idCampanha");

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isProgress, setIsisProgress] = useState(false);
  const [titleConfirmacao, setTitleConfirmacao] = useState("");
  const [nome, setNome] = useState("");
  const [Progress, setProgressBarValue] = useState(0);
  const [ProgressBar, setProgressBar] = useState(false);
  const [tipo, setTipo] = useState("");
  const [cenario, setCenario] = useState("");
  const [inicio, setInicio] = useState("");
  const [fim, setFim] = useState("");
  const [RegraMsmCmp, setRegraMsmCmp] = useState("");

  const [RegraQqrCmp, setRegraQqrCmp] = useState("");
  const [RegraTipoCmp, setRegraTipoCmp] = useState("");
  const [audiencia, setQMA] = useState<number>(0);
  const [funcionario, setFuncionario] = useState(0);
  const [procon, setProcon] = useState(0);
  const [conta, setConta] = useState(0);
  const [openConfirmacao, setOpenConfirmacao] = useState(false);
  const [messageConfirmacao, setMessageConfirmacao] = useState("");
  const [showSave, setShowSave] = useState(false);
  const [showTest, setShowTest] = useState(false);
  const [queryBusinessValue, setQueryBusinessValue] = useState("");
  const [selectedItem, setSelectedItem] = useState<ICampanhas | string>("0");
  const [ids, setIds] = useState<ICampanhas[]>([]);
  const [campanhas, setCampanhas] = useState<ICampanhas[]>([]);
  const [campanha, setCampanha] = useState<IDetalheCampanha[]>([]);
  const [idUser, setIdUser] = useState(0);
  const org = useSelectedOrganization();
  const [rows, setRows] = useState<IListagemCribLog[]>([]);

  const handlePreviewSave = () => {
    setShowSave(true);
    trigger();
  };

  useEffect(() => {
    if (selectedItem) {
      setIsisProgress(true);
      setTimeout(() => {
        setIsisProgress(false);
      }, 2000);
    }
  }, [selectedItem]);


  useEffect(() => {
    if (selectedItem!=="0"){
    setAlert(null);

    CribService.getById(
      Number(org?.CodigoOrganizacao),
      String(selectedItem)
    ).then((result) => {
      if (result instanceof Error) {
        console.log(result.message);
        if (result.message == "Request failed with status code 409"){
        setAlert({
          text: "A campanha não está em elaboração",
          type: "error",
        });
      }
      } else {
        setIsLoading(false);
        setSmsMaxAud(-1);
        setIsVisibleSms(false);
        setEmailMaxAud(-1);
        setIsVisibleEmail(false);
        setPushMaxAud(-1);
        setIsVisiblePush(false);
        setQMA(result.Coms[0].quantidadeMaxAudiencia);
        CalcMaxAudiencia(result.Coms);
        setQueryCampanha(result.QueryCampanha===null?"":result.QueryCampanha);
        setValue("queryBusiness", result.QueryCampanha===null?"":result.QueryCampanha);
        setGcTypeComunicacao(result.CMPCOM_TP_CALC_GRP_CONTROLE);
        setGcHelperComunicacao(result.CMPCOM_TAM_GRP_CONTROLE);
        setTipoCampanha(result.TipoCampanha);
        setCanal(result.Coms);
        setNome(result.NomeCampanha);
        setCenario(result.Cenario);
        setTipo(result.TipoCampanha);
        setInicio(result.DataCampanhaInicio);
        setFim(result.DataCampanhaTermino);
        setProcon(result.RegrasExc[1].IdRegraExclusao ? 2 : 0);
        setFuncionario(result.RegrasExc[0].IdRegraExclusao ? 1 : 0);

        setConta(result.RegrasExc[2].IdRegraExclusao ? 3 : 0);
      }
    });
  }
  }, [selectedItem]);



  const handleDelete = () => {
    setTitleConfirmacao(t("components.actions.apagar"));
    setMessageConfirmacao(
      t("messages.organizationSeletion.exclusion") + id + "?"
    );
    setOpenConfirmacao(true);
    console.log("handleDelete");
  };

  const confirmDelete = () => {
    setAlert(null);
    OrganizationsService.deleteById(id)
      .then((result) => {
        if (result instanceof Error) {
          setAlert({
            text: result.message,
            type: "error",
          });
          setOpenConfirmacao(false);
        } else {
          setAlert({
            text: "Registro apagado com sucesso!",
            type: "error",
          });
          navigate("/organizacao/listagem");
        }
      })
      .catch((reason) => {
        setAlert({
          text: reason,
          type: "error",
        });
        setOpenConfirmacao(false);
      });
  };

  const onSubmit = async (data: IUpdateCrib) => {
    setAlert(null);
    setIsSubmitting(true);

    const generatedUuid = uuid.v4();
    const md5Hash = crypto.createHash("md5");
    md5Hash.update(generatedUuid);
    const idExec = md5Hash.digest("hex");

    if (data.grupoControle !== undefined && data.calcGrupo !== undefined) {
      data.grupo_controle = Number(data.grupoControle) + Number(data.calcGrupo);
    }
    if (selectGC === 1 && data.porcentagem !== undefined) {
      data.Calculo_Grupo = Number(data.porcentagem) / 100;
    } else if (selectGC === 2 && data.valorInteiro !== undefined) {
      data.Calculo_Grupo = Number(data.valorInteiro);
    } else if (selectGC === 3) {
      data.Calculo_Grupo = 0;
    } else if (
      selectGC === 4 &&
      data.inicioRange !== undefined &&
      data.fimRange !== undefined
    ) {
      const ini = String(data.inicioRange).padStart(2, "0");
      const fim = String(data.fimRange).padStart(2, "0");
      const Vfinal = ini + fim;
      data.Calculo_Grupo = Number(Vfinal);
    }
    data.status = "ELAB";
    data.TipoCampanha = tipoCampanha;
    data.idCanal = Canal;

    CribService.update(
      Number(selectedItem),
      Number(org?.CodigoOrganizacao),
      data
    )
      .then((result) => {
        setIsLoading(false);

        if (result instanceof Error) {
          setAlert({
            text: result.message,
            type: "error",
          });
        } else {
          setAlert({
            text: "Dados alterados com Sucesso",
            type: "success",
          });
          setTimeout(() => {
            setAlert({
              text: "Crib Em Execução",
              type: "info",
            });
          }, 2000);
          CribService.ExecBD(
            Number(selectedItem),
            Number(idUser),
            Number(org?.CodigoOrganizacao),
            String(
              AMB == "LOCAL"
                ? "des"
                : AMB == "DESENVOLVIMENTO"
                ? "des"
                : AMB == "HOMOLOGAÇÂO"
                ? "hom"
                : "prd"
            ),
            idExec,
            String(selectFlag)
          ).then((result) => {
            if (result instanceof Error) {
              setAlert({
                text: "Falha na Execução",
                type: "error",
              });
              navigate("/crib/listagem");
            } else {
              setAlert({
                text: " Executado com sucesso",
                type: "success",
              });
              const intervalId = setInterval(() => {
                CribService.getLog(
                  Number(org?.CodigoOrganizacao),
                  Number(selectedItem),
                  idExec
                )
                  .then((result) => {
                    setIsLoading(false);
                    if (result instanceof Error) {
                      setAlert({
                        text: result.message,
                        type: "error",
                      });
                    } else {
                      setAlert({
                        text: "Gerando Audiência",
                        type: "info",
                      });
                      setShowTest(true);
                      setRows(result.cribLogList);
                      setProgressBar(true);

                      const maxStep = 7;
                      const progress =
                        (result.cribLogList.length / maxStep) * 100;
                      setProgressBarValue(progress);
                      const finishConditionMet = result.cribLogList.some(
                        (row) => {
                          if (
                            row.StepJson.includes("True") &&
                            result.cribLogList.length > 6
                          ) {
                            setRows(result.cribLogList);
                            return true;
                          } else if (row.StepJson.includes("False")) {
                            setAlert({
                              text: "Falha na Execução do Crib",
                              type: "error",
                            });
                            return true;
                          }
                          return false;
                        }
                      );

                      if (finishConditionMet) {
                        clearInterval(intervalId);
                        setAlert({
                          text: "Audiência Finalizada",
                          type: "success",
                        });
                        setProgressBar(false);
                      }
                    }
                  })
                  .finally(() => {
                    setIsSubmitting(false);
                  });
              }, 8000);

              setShowSave(true);
            }
            setIsLoading(false);
          });
        }
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  useEffect(() => {
    async function loadRoles() {
      const response = await UsuariosService.getMe();

      if (!(response instanceof Error)) {
        setIdUser(response.idUsuario);
      }
    }
    loadRoles();
  }, []);

  const handleTest = () => {
    CribService.GetTest(
      Number(lastIdExec),
      Number(selectedItem),
      Number(org?.CodigoOrganizacao)
    ).then((result) => {
      if (result instanceof Error) {
        setAlert({
          text: result.message,
          type: "error",
        });
        navigate("/crib/listagem");
      } else {
        setAlert({
          text: result.toString(),
          type: "info",
        });
      }
    });
  };



  // #region correções Text Field

  const handleSaveQuery = () => {
    CribService.SaveQuery(Number(lastIdExec), Number(selectedItem)).then(
      (result) => {
        if (result instanceof Error) {
          setAlert({
            text: result.message,
            type: "error",
          });
          navigate("/crib/listagem");
        } else {
          setAlert({
            text: result.toString(),
            type: "info",
          });
        }
      }
    );
  };

  // #region Query Business

  const textFieldRef = useRef<HTMLDivElement>(null);

  const handleClickAway = (event: MouseEvent | TouchEvent) => {
    if (
      textFieldRef.current &&
      !textFieldRef.current.contains(event.target as Node)
    ) {
      setFocarTitle(false);
    }
  };

  const handleClickInside = () => {
    setFocarTitle(true);
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickAway);
    document.addEventListener("touchstart", handleClickAway);

    return () => {
      document.removeEventListener("mousedown", handleClickAway);
      document.removeEventListener("touchstart", handleClickAway);
    };
  }, []);
  // #endregion

  // #region Percentage

  const textFieldRefPerc = useRef<HTMLDivElement>(null);

  const handleClickAwayPerc = (event: MouseEvent | TouchEvent) => {
    if (
      textFieldRef.current &&
      !textFieldRef.current.contains(event.target as Node)
    ) {
      setFocarTitlePerc(false);
    }
  };

  const handleClickInsidePerc = () => {
    setFocarTitlePerc(true);
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickAway);
    document.addEventListener("touchstart", handleClickAway);

    return () => {
      document.removeEventListener("mousedown", handleClickAway);
      document.removeEventListener("touchstart", handleClickAway);
    };
  }, []);
  // #endregion

  // #region Inteiro

  const textFieldRefInt = useRef<HTMLDivElement>(null);

  const handleClickAwayInt = (event: MouseEvent | TouchEvent) => {
    if (
      textFieldRef.current &&
      !textFieldRef.current.contains(event.target as Node)
    ) {
      setFocarTitleInt(false);
    }
  };

  const handleClickInsideInt = () => {
    setFocarTitleInt(true);
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickAway);
    document.addEventListener("touchstart", handleClickAway);

    return () => {
      document.removeEventListener("mousedown", handleClickAway);
      document.removeEventListener("touchstart", handleClickAway);
    };
  }, []);
  // #endregion

  // #region InicioRange

  const textFieldRefIR = useRef<HTMLDivElement>(null);

  const handleClickAwayIR = (event: MouseEvent | TouchEvent) => {
    if (
      textFieldRef.current &&
      !textFieldRef.current.contains(event.target as Node)
    ) {
      setFocarTitleIR(false);
    }
  };

  const handleClickInsideIR = () => {
    setFocarTitleIR(true);
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickAway);
    document.addEventListener("touchstart", handleClickAway);

    return () => {
      document.removeEventListener("mousedown", handleClickAway);
      document.removeEventListener("touchstart", handleClickAway);
    };
  }, []);
  // #endregion

  // #region FimRange

  const textFieldRefFR = useRef<HTMLDivElement>(null);

  const handleClickAwayFR = (event: MouseEvent | TouchEvent) => {
    if (
      textFieldRef.current &&
      !textFieldRef.current.contains(event.target as Node)
    ) {
      setFocarTitleFR(false);
    }
  };

  const handleClickInsideFR = () => {
    setFocarTitleFR(true);
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickAway);
    document.addEventListener("touchstart", handleClickAway);

    return () => {
      document.removeEventListener("mousedown", handleClickAway);
      document.removeEventListener("touchstart", handleClickAway);
    };
  }, []);
  // #endregion

  // #region FimRange

  const textFieldRefCampanha = useRef<HTMLDivElement>(null);

  const handleClickAwayCampanha = (event: MouseEvent | TouchEvent) => {
    if (
      textFieldRef.current &&
      !textFieldRef.current.contains(event.target as Node)
    ) {
      setFocarTitleCampanha(false);
    }
  };

  const handleClickInsideCampanha = () => {
    setFocarTitleCampanha(true);
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickAway);
    document.addEventListener("touchstart", handleClickAway);

    return () => {
      document.removeEventListener("mousedown", handleClickAway);
      document.removeEventListener("touchstart", handleClickAway);
    };
  }, []);
  // #endregion

  // #endregion

  const handleSubmitIdCampanha = async () => {
    console.log(selectCampanha);
    setSelectedItem(selectCampanha.toString() as ICampanhas);
  };

  // Visibilidade Max audiencia
  const [smsMaxAud, setSmsMaxAud] = useState<number>(-1);
  const [emailMaxAud, setEmailMaxAud] = useState<number>(-1);
  const [pushMaxAud, setPushMaxAud] = useState<number>(-1);
  const [wppMaxAud, setWppMaxAud] = useState<number>(-1);

  function CalcMaxAudiencia(Coms: IComunicacao[]) {
    // 0 - SMS
    // 1 - Email
    // 2 - Push

    const comsLength = Coms.length;
    let aux = 0;

    for (let i = 0; i < comsLength; i++) {
      aux = Coms[i].quantidadeMaxAudiencia;
        if (Coms[i].idCanal === 1) {
          setSmsMaxAud(aux);
          setIsVisibleSms(true);
        } else if (Coms[i].idCanal === 2) {
          setEmailMaxAud(aux);
          setIsVisibleEmail(true);
        } else if (Coms[i].idCanal === 3) {
          setPushMaxAud(aux);
          setIsVisiblePush(true);
        } else if (Coms[i].idCanal === 6) {
          setWppMaxAud(aux);
          setIsVisibleWpp(true);
        }
    }
  }

  const formatRegex = (value: string): string => {
    const regex = /\{"(\d+)":\s*(\d+)(,\s*"\d+":\s*\d+)*\}/;
    const matches = value.match(regex);
  
    if (matches) {
      return value.replace(/"(\d+)":\s*(\d+)/g, (match, p1, p2) => {
        return `Canal ${p1}: ${p2}`;
      }).replace(/[{}]/g, '');
    }
    return '';
  };
  function formatString(input: string) {
    const regex = /\{"(\d+)":\s*(\d+)(,\s*"\d+":\s*\d+)*\}/;  
    // if (input.includes("action_group") && input.includes("control_group")) {
      
    //   const parts = input.split(",");
    //   const parts2 = parts[0].split(': {"control_group": ');

    //   const canal = parts2[0].replace("{", "");
    //   const grupoControle = parts2[1];
    //   const grupoAcao = parts[1].replace(' "action_group": ', "").replace("}}", "");

    //   return `Canal: ${canal} | Grupo de controle: ${grupoControle} | Grupo de ação: ${grupoAcao}`;
    // }

    // else if (input.includes("action_group")) {
    //   const parts = input.split(":");

    //   if (parts.length >= 3) {
    //     const canal = parts[0].trim();
    //     const grupoAcao = parts[2].trim();

    //     return `Canal: ${canal.replace("{", "")} | Grupo de ação: ${grupoAcao
    //       .replace("}", "")
    //       .replace("}", "")}`;
    //   }
    // } 
    if (input.includes('"validation_error":')) {
      return input.replace('{"validation_error": "', "").replace(' "}', "");
    }
    else if (input.includes('"erro":')) {
      return input.replace('"erro": "', "").replace('"', "").replace("{", "").replace("}", "");
    }
    else if (input.includes("df_business_len")) {
      const parts = input.split(":");

      if (parts.length >= 1) {
        const tamAudiencia = parts[1].trim();

        return `Tamanho da audiência: ${tamAudiencia.replace("}", "")}`;
      }
    } 
    else if (input.includes("EXCLUDE_EMPLOYEE")) {
      
      return`${input.replace("{", "").replace("}", "")}`;
    }
    else if (regex.test(input)) {
      return formatRegex(input);
    }
    else if (input === "{}") {
      return "";
    }

    const parts = input.split(":");

    if (parts.length == 2) {
      const canal = parts[0].trim();
      const qtdPessoas = parts[1].trim();

      return `Canal: ${canal
        .replace("{", "")
        .replace("}", "")}: ${qtdPessoas.replace("}", "")}`;
    }
    else return input.replace("{", "")
    .replace("}", "");
  }

  return (
    <LayoutBaseDePagina
      titulo={""}
      TituloCrib={"Crib 1.2"}
      barraDeFerramentas={
        !(isLoading || isSubmitting) && (
          <FerramentasDeDetalhe
            idForm="formDetalheDeOrganizacao"
            textoBotaoNovo={t("components.actions.novo")}
            mostrarBotaoNovo={id !== "novo" && hasPermitionCreate}
            mostrarBotaoApagar={id !== "novo" && hasPermitionDelete}
            mostrarBotaoSalvar={false}
            aoClicarEmSalvar={save}
            aoClicarEmVoltar={() => navigate("/")}
            aoClicarEmApagar={() => handleDelete()}
            aoClicarEmNovo={() => navigate("/organizacao/detalhe/novo")}
          />
        )
      }
    >
      <Box
        ref={formRef}
        id="formDetalheDeOrganizacao"
        component="form"
        display="flex"
        flexDirection="column"
        autoComplete="off"
        onSubmit={handleSubmit(onSubmit)}
        overflow="hidden"
      >
        <Box
          margin={1}
          display="flex"
          flexDirection="column"
          component={Paper}
          variant="outlined"
          width="100%"
        >
          <Card>
            {ProgressBar && (
              <LinearProgress
                value={Progress}
                variant="determinate"
                style={{
                  height: "20px",
                  color: "blue",
                  backgroundColor: "white",
                  borderRadius: "5px",
                }}
              />
            )}
            <CardContent sx={{ padding: 0 }}>
              <div>
                {alert ? (
                  <>
                    <Grid item xs={12} paddingX={2}>
                      <Alert
                        severity={alert.type}
                        onClose={() => setAlert(null)}
                        sx={{ marginTop: "1rem", marginBottom: "0" }}
                      >
                        {alert.text}
                      </Alert>
                    </Grid>
                  </>
                ) : (
                  <Grid item xs={12} component={Typography} paddingX={2}></Grid>
                )}
                <Grid container>
                  <Grid
                    item
                    xs={2}
                    style={{ marginLeft: "10px", marginTop: "10px" }}
                  >
                    <Grid item xs={11} paddingX={2}>
                      <ClickAwayListener onClickAway={handleClickAwayCampanha}>
                        <div ref={textFieldRefCampanha}>
                          <TextField
                            autoFocus={focarTitleCampanha}
                            // error={!!errors?.queryBusiness}
                            fullWidth
                            multiline
                            rows={2}
                            disabled={
                              isSubmitting ||
                              isLoading ||
                              (!hasPermitionUpdate && id !== "novo")
                            }
                            id="idCampanha"
                            type="text"
                            onClick={handleClickInsideCampanha}
                            placeholder={"Id Campanha"}
                            {...register("idCampanha")}
                            sx={{ marginTop: "0", marginBottom: "0" }}
                            inputProps={{
                              maxLength: 10000,
                              style: {
                                fontFamily: "Courier New",
                                fontSize: "16px",
                                color: "blue",
                              },
                            }}
                          />
                        </div>
                      </ClickAwayListener>
                    </Grid>

                    <Grid
                      item
                      xs={11}
                      paddingX={2}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Button
                        color="info"
                        variant="contained"
                        fullWidth
                        onClick={handleSubmitIdCampanha}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {"Inserir Id Campanha"}
                      </Button>
                    </Grid>
                  </Grid>
                  {isProgress ? (
                    <Grid
                      item
                      xs={9}
                      style={{
                        marginTop: "10px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {" "}
                      <CircularProgress />
                    </Grid>
                  ) : (
                    <>
                      {selectedItem!=="0" ? (
                        <Grid item xs={9} style={{ marginTop: "10px" }}>
                          <Card
                            style={{ width: 'auto', height: 'auto' }}
                          >
                            <Box style={{ width: 'auto', height: 'auto' }}>
                              <CardContent
                                sx={{
                                  padding: '16px', height: 'auto', width:'auto', overflow: 'visible'
                                }}
                              >
                                <>
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "row",
                                    }}
                                  >
                                    <ul style={{ listStyleType: "none", fontFamily: "Arial, Helvetica, sans-serif" }}>
                                      <li>
                                        <b>Nome</b>: {nome}
                                      </li>
                                      <li>
                                        <b>Tipo</b>: {tipo}
                                      </li>
                                      <li>
                                        <b>Cenário</b>: {cenario}
                                      </li>
                                      <li>
                                        <b>Regras de Exclusão</b>:{" "}
                                        {funcionario === 1
                                          ? "Funcionario "
                                          : ""}{" "}
                                        {procon === 2 ? "Procon " : ""}{" "}
                                        {conta === 3 ? "Conta" : ""}
                                      </li>
                                    </ul>

                                    <ul style={{ listStyleType: "none", fontFamily: "Arial, Helvetica, sans-serif" }}>
                                      <li>
                                        <b>Início</b>: 
                                        {stringToDateTime(inicio)}
                                      </li>
                                      <li>
                                        <b>Fim</b>: {stringToDateTime(fim)}{" "}
                                      </li>
                                      {isVisibleSms && (
                                        <li>
                                          <b>Audiência Limite SMS</b>: {smsMaxAud}{" "}
                                        </li>
                                      )}
                                      {isVisibleEmail && (
                                        <li>
                                          <b>Audiência Limite Email</b>: {emailMaxAud}{" "}
                                        </li>
                                      )}
                                      {isVisiblePush && (
                                        <li>
                                          <b>Audiência Limite Push</b>: {pushMaxAud}{" "}
                                        </li>
                                      )}
                                      {isVisibleWpp && (
                                        <li>
                                          <b>Audiência Limite WhatsApp</b>: 
                                          {wppMaxAud}{" "}
                                        </li>
                                      )}



                                      {selectPercent ? (
                                        <li>
                                          <b>
                                            Tamanho Máximo Grupo de Controle{" "}
                                          </b>
                                          :
                                          {selectPercent !== undefined
                                            ? selectPercent + "%"
                                            : ""}
                                        </li>
                                      ) : (
                                        ""
                                      )}
                                      {selectGC ? (
                                        <li>
                                          <b>Tipo de Grupo de Controle</b>:
                                          {selectGC === 1
                                            ? "Porcentagem"
                                            : selectGC === 2
                                            ? "Inteiro"
                                            : selectGC === 3
                                            ? "Função"
                                            : selectGC === 4
                                            ? "Range Cpf"
                                            : ""}{" "}
                                        </li>
                                      ) : (
                                        ""
                                      )}

                                      
                                    </ul>

                                    <ul style={{ listStyleType: "none", fontFamily: "Arial, Helvetica, sans-serif" }}>
                                      <li>
                                        <b>GC cadastrado</b>: 
                                        <span style={{ 
                                          color: gcTypeComunicacao ? 'green' : 'red',
                                          fontWeight: 'bold'
                                        }}>
                                          {gcTypeComunicacao ? ` ${
                                            (() => {
                                              const gcValue = parseInt(gcTypeComunicacao);
                                              
                                              // Handle single digits (1, 2, 3, 4)
                                              if (gcValue >= 1 && gcValue <= 4) {
                                                switch(gcValue) {
                                                  case 1:
                                                    return `Canal Porcentagem`;
                                                  case 2:
                                                    return `Canal Inteiro`;
                                                  case 3:
                                                    return `Canal Fórmula`;
                                                  case 4:
                                                    return `Canal Range CPF`;
                                                  default:
                                                    return gcTypeComunicacao;
                                                }
                                              }
                                              
                                              // Handle multi-digit values
                                              const prefix = gcValue > 40 ? "Geral" : "Canal";
                                              const lastDigit = gcValue % 10;
                                              let suffix = "";
                                              
                                              switch(lastDigit) {
                                                case 1:
                                                  suffix = "Porcentagem";
                                                  break;
                                                case 2:
                                                  suffix = "Inteiro";
                                                  break;
                                                case 3:
                                                  suffix = "Fórmula";
                                                  break;
                                                case 4:
                                                  suffix = "Range CPF";
                                                  break;
                                                default:
                                                  suffix = "";
                                              }
                                              
                                              return `${prefix} ${suffix}`;
                                            })()
                                          }` : ' NÃO'}
                                        </span>
                                      </li>
                                      {gcTypeComunicacao && parseInt(gcTypeComunicacao) % 10 !== 3 && (
                                        <li>
                                          <b>GC Valor</b>:  
                                          <span style={{ 
                                            color: 'blue',
                                            fontWeight: 'bold'
                                          }}>
                                            {` ${gcHelperComunicacao}`} 
                                          </span>
                                        </li>
                                      )}
                                    </ul>


                                  </div>
                                </>
                              </CardContent>
                            </Box>
                          </Card>
                        </Grid>
                      ) : (
                        <Grid
                          item
                          xs={9}
                          paddingX={2}
                          style={{ marginTop: "10px" }}
                        >
                          <Card>
                            <CardContent
                              style={{
                                height: "15px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <h2
                                style={{
                                  textAlign: "center",
                                }}
                              >
                                Selecione uma campanha !!{" "}
                              </h2>
                            </CardContent>
                          </Card>
                        </Grid>
                      )}
                    </>
                  )}

                  <Grid item xs={4} paddingX={2}>
                    <FormControl
                      fullWidth
                      sx={{ marginTop: "1rem", marginBottom: "0" }}
                    >
                      <InputLabel id="label-select-tipo">{`${t(
                        "pages.crib.grupoControle"
                      )} *`}</InputLabel>
                      <Select
                        disabled={
                          isSubmitting ||
                          isLoading ||
                          (!hasPermitionUpdate && id !== "novo")
                        }
                        error={errors?.grupoControle?.type ? true : false}
                        labelId="label-select-tipo"
                        id="grupoControle"
                        type="number"
                        input={
                          <OutlinedInput
                            label={`${t("pages.grupoTeste.tipo")} *`}
                          />
                        }
                        {...register("grupoControle")}
                        value={selectTipoGC}
                      >
                        <MenuItem value="">
                          <ListItemText primary="" />
                        </MenuItem>
                        {listKeyValueGrupoControle.map((item) => (
                          <MenuItem key={item.key} value={item.key}>
                            <ListItemText
                              primary={item.value}
                              sx={{ margin: "0" }}
                            />
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    {errors?.grupoControle?.type && (
                      <InputError
                        type={errors.grupoControle.type}
                        field="grupoControle"
                      />
                    )}
                  </Grid>
                  <Grid item xs={4} paddingX={2}>
                    <FormControl
                      fullWidth
                      sx={{ marginTop: "1rem", marginBottom: "0" }}
                    >
                      <InputLabel id="label-select-tipo">{`${t(
                        "pages.crib.calculoGrupoControle"
                      )} *`}</InputLabel>
                      <Select
                        disabled={
                          isSubmitting ||
                          isLoading ||
                          (!hasPermitionUpdate && id !== "novo")
                        }
                        error={errors?.calcGrupo?.type ? true : false}
                        labelId="label-select-tipo"
                        id="calcGrupo"
                        input={
                          <OutlinedInput
                            label={`${t("pages.grupoTeste.tipo")} *`}
                          />
                        }
                        {...register("calcGrupo")}
                        value={selectGC}
                      >
                        <MenuItem value="">
                          <ListItemText primary="" />
                        </MenuItem>
                        {listKeyValueCalculoGC.map((item) => (
                          <MenuItem key={item.key} value={item.key}>
                            <ListItemText
                              primary={item.value}
                              sx={{ margin: "0" }}
                            />
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    {errors?.calcGrupo?.type && (
                      <InputError
                        type={errors.calcGrupo.type}
                        field="calcGrupo"
                      />
                    )}
                  </Grid>
                  {selectGC === 1 ? (
                    <>
                      <Grid item xs={4} paddingX={2}>
                        <ClickAwayListener onClickAway={handleClickAwayPerc}>
                          <div ref={textFieldRefPerc}>
                            <TextField
                              onClick={handleClickInsidePerc}
                              autoFocus={focarTitlePerc}
                              error={errors?.porcentagem?.type ? true : false}
                              fullWidth
                              disabled={
                                isSubmitting ||
                                isLoading ||
                                (!hasPermitionUpdate && id !== "novo")
                              }
                              id="porcentagem"
                              type="number"
                              placeholder={`${t("pages.crib.porcentagem")} *`}
                              {...register("porcentagem")}
                              sx={{ marginTop: "1rem", marginBottom: "0" }}
                            />
                          </div>
                        </ClickAwayListener>
                        {errors?.porcentagem?.type && (
                          <InputError
                            type={errors.porcentagem.type}
                            field="porcentagem"
                          />
                        )}
                      </Grid>
                    </>
                  ) : (
                    ""
                  )}
                  {selectGC === 2 ? (
                    <>
                      <Grid item xs={4} paddingX={2}>
                        <ClickAwayListener onClickAway={handleClickAwayInt}>
                          <div ref={textFieldRefInt}>
                            <TextField
                              onClick={handleClickInsideInt}
                              autoFocus={focarTitleInt}
                              error={errors?.valorInteiro?.type ? true : false}
                              fullWidth
                              disabled={
                                isSubmitting ||
                                isLoading ||
                                (!hasPermitionUpdate && id !== "novo")
                              }
                              id="valorInteiro"
                              type="text"
                              placeholder={`${t("pages.crib.valorInteiro")} *`}
                              {...register("valorInteiro")}
                              sx={{ marginTop: "1rem", marginBottom: "0" }}
                            />
                          </div>
                        </ClickAwayListener>
                        {errors?.valorInteiro?.type && (
                          <InputError
                            type={errors.valorInteiro.type}
                            field="valorInteiro"
                          />
                        )}
                      </Grid>
                    </>
                  ) : (
                    ""
                  )}
                  {selectGC === 4 ? (
                    <>
                      <Grid item xs={3} paddingX={2}>
                        <ClickAwayListener onClickAway={handleClickAwayIR}>
                          <div ref={textFieldRefIR}>
                            <TextField
                              onClick={handleClickInsideIR}
                              autoFocus={focarTitleIR}
                              error={errors?.inicioRange?.type ? true : false}
                              fullWidth
                              disabled={
                                isSubmitting ||
                                isLoading ||
                                (!hasPermitionUpdate && id !== "novo")
                              }
                              id="inicioRange"
                              type="text"
                              placeholder={`${t("pages.crib.inicioRange")} *`}
                              {...register("inicioRange")}
                              sx={{ marginTop: "1rem", marginBottom: "0" }}
                            />
                          </div>
                        </ClickAwayListener>
                        {errors?.inicioRange?.type && (
                          <InputError
                            type={errors.inicioRange.type}
                            field="inicioRange"
                          />
                        )}
                      </Grid>

                      <Grid item xs={3} paddingX={2}>
                        <ClickAwayListener onClickAway={handleClickAwayFR}>
                          <div ref={textFieldRefFR}>
                            <TextField
                              onClick={handleClickInsideFR}
                              autoFocus={focarTitleFR}
                              error={errors?.fimRange?.type ? true : false}
                              fullWidth
                              disabled={
                                isSubmitting ||
                                isLoading ||
                                (!hasPermitionUpdate && id !== "novo")
                              }
                              id="fimRange"
                              type="text"
                              placeholder={`${t("pages.crib.fimRange")} *`}
                              {...register("fimRange")}
                              sx={{ marginTop: "1rem", marginBottom: "0" }}
                            />
                          </div>
                        </ClickAwayListener>
                        {errors?.fimRange?.type && (
                          <InputError
                            type={errors.fimRange.type}
                            field="fimRange"
                          />
                        )}
                      </Grid>
                    </>
                  ) : (
                    ""
                  )}
                  <Grid item xs={11} paddingX={2}>
                    <ClickAwayListener onClickAway={handleClickAway}>
                      <div ref={textFieldRef}>
                        <TextField
                          autoFocus={focarTitle}
                          error={!!errors?.queryBusiness}
                          fullWidth
                          multiline
                          rows={15}
                          disabled={
                            isSubmitting ||
                            isLoading ||
                            (!hasPermitionUpdate && id !== "novo")
                          }
                          id="queryBusiness"
                          type="text"
                          onFocus={handleClickInside}
                          placeholder={`${t("pages.crib.queryBusiness")} *`}
                          {...register("queryBusiness")}
                          sx={{ marginTop: "1rem", marginBottom: "0" }}
                          inputProps={{
                            style: {
                              fontFamily: "Courier New",
                              fontSize: "16px",
                              color: "blue",
                            },
                            onKeyDown: (e: React.KeyboardEvent) => {
                              e.stopPropagation();
                            },
                            onMouseDown: (e: React.MouseEvent) => {
                              e.stopPropagation();
                            },
                          }}
                        />
                      </div>
                    </ClickAwayListener>
                    {errors?.queryBusiness && (
                      <span style={{ color: "red" }}>
                        {errors.queryBusiness.message}
                      </span>
                    )}
                  </Grid>

                  <Grid
                    item
                    xs={1}
                    paddingX={2}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Button
                      color="info"
                      variant="contained"
                      size="medium"
                      onClick={handleSubmitCrib}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {" "}
                      <PlayCircleOutlineIcon style={{ marginRight: "8px" }} />
                    </Button>
                  </Grid>

                  <Grid
                    item
                    xs={1}
                    paddingX={2}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginTop: "1rem",
                      marginBottom: "0",
                    }}
                  >
                    <Button
                      color="info"
                      variant="contained"
                      size="medium"
                      onClick={handleClickLog}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {"Log"}
                    </Button>
                  </Grid>
                </Grid>
              </div>
            </CardContent>
          </Card>
        </Box>
        <Box
          margin={1}
          display="flex"
          flexDirection="column"
          component={Paper}
          variant="outlined"
          width="100%"
          height="100%"
        >
          {showTest && (
            <TableContainer component={Paper}>
              <Table
                stickyHeader
                sx={{ minWidth: 650 }}
                size="small"
                aria-label="a dense table"
              >
                <TableHead>
                  <TableRow
                    sx={{
                      textAlign: "center",
                      backgroundColor: "#e6e6e6",
                      color: "black",
                      "&:last-child td, &:last-child th": { border: 0 },
                    }}
                  >
                    <TableCell>Id Campanha</TableCell>
                    <TableCell>Id Exec</TableCell>
                    <TableCell>Log</TableCell>
                    <TableCell>Descrição</TableCell>
                    <TableCell>Data/Hr Exec</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                    {rows
                      .sort((a, b) => {                   
                        return a.Step - b.Step;
                      })
                      .map((row) => (
                        <TableRow key={row.IdCampanha}>
                          <TableCell style={{ fontSize: "14px" }}>
                            {row.IdCampanha}
                          </TableCell>
                          <TableCell style={{ fontSize: "14px" }}>
                            {row.IdExec}
                          </TableCell>
                          <TableCell style={{ fontSize: "14px", wordBreak: "break-word", whiteSpace: "normal" }}>
                            {row.StepJson === '{"final_crib_execution": "True"}'
                              ? "AUDIENCIA FINALIZADA"
                              : row.StepJson && (
                                  <div>
                                    {formatString(row.StepJson)}
                                  </div>
                                )}
                          </TableCell>
                          <TableCell style={{ fontSize: "14px" }}>
                            {row.StepDesc}
                          </TableCell>
                          <TableCell style={{ fontSize: "14px" }}>
                            {stringToDateTime(row.StepDth.toString())}
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>              
              </Table>
            </TableContainer>
          )}
        </Box>

        {showTest && (
          <Button
            sx={{
              top: 0,
              left: 0,
              bottom: 10,
              right: 0,
            }}
            color="info"
            variant="contained"
            size="large"
            onClick={handleTest}
          >
            Teste
          </Button>
        )}

        {showTest && (
          <Button
            sx={{
              top: 0,
              left: 0,
              bottom: 0,
              right: 0,
            }}
            color="info"
            variant="contained"
            size="large"
            onClick={handleSaveQuery}
          >
            Salvar Query
          </Button>
        )}

        <ConfirmacaoModal
          open={openConfirmacao}
          title={titleConfirmacao}
          message={messageConfirmacao}
          onClose={() => setOpenConfirmacao(false)}
          onConfirm={() => confirmDelete()}
        />
      </Box>
      {(isLoading || isSubmitting) && (
        <Box
          sx={{
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: "absolute",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress />
        </Box>
      )}
      <Snackbar
        open={open}
        autoHideDuration={3000}
        onClose={() => setOpen(false)}
      >
        <Alert severity={severity} sx={{ width: "100%" }}>
          {errorMessage}
        </Alert>
      </Snackbar>
    </LayoutBaseDePagina>
  );
};
function padStart(arg0: number, arg1: number) {
  throw new Error("Function not implemented.");
}
